// src/pages/Home.js
import React from 'react';

function Home() {
  return <h1>Bienvenido a la página de inicio</h1>;
}

export default Home;
